import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useInspectraDashboard } from "../../../Hooks/Features/Inspectra/useInspectraDashboard";
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useCommon } from "../../../Hooks/Common/useCommon";
import { Dropdown } from "primereact/dropdown";

const ResponsiveGridLayout = WidthProvider(Responsive);

const InspectraDashboard = () => {

    const { widget, layout, autopopData, tagRef, projectOptions, selectedProject, setSelectedProject, callApi, selectedTab, setSelectedTab } = useInspectraDashboard();
    const { checkPermission } = useCommon()

    const responsiveProps = {
        className: 'layout',
        breakpoints: { lg: 1200, md: 800, sm: 668, xs: 420, xxs: 0 },
        cols: { lg: 60, md: 50, sm: 30, xs: 20, xxs: 10 },
        isResizable: false,
        isDraggable: false,
        compactType: 'vertical',
        rowHeight: 20,
        layouts: { lg: layout },
    };

    return (
        <div>
            <div className="d-flex gap-5 align-items-center" style={{
                position: "sticky", top: "40px", zIndex: 30, background: "white"
            }}>
                <div className="w25 header-tab">
                    <ul className="nav">
                        <li className="nav-item" onClick={() => setSelectedTab("error")}>
                            <div className={`nav-link c-pointer ${selectedTab === "error" ? "active" : "text-black"}`}><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /> Error View</div>
                        </li>
                        <li className="nav-item" onClick={() => setSelectedTab("info")}>
                            <div className={`nav-link c-pointer ${selectedTab === "info" ? "active" : "text-black"}`}><FontAwesomeIcon icon="fa-solid fa-circle-info" /> Information View</div>
                        </li>
                    </ul>
                </div>
                <div className="w15">
                    <Dropdown placeholder="Project" options={projectOptions} optionLabel="project_name" value={selectedProject} onChange={(e) => setSelectedProject(e.target.value)} filter filterInputAutoFocus />
                </div>
            </div>
            <div ref={() => checkPermission("inspectra", tagRef)}>
                <div ref={tagRef} id='{"tabname": "inspectra", "data": "inspectra_dashboard_tab"}'>
                    <ResponsiveGridLayout {...responsiveProps}>
                        {widget?.map((item, index) => (
                            <div key={index} style={{ borderRadius: "10px", boxShadow: "rgb(215 214 214) 1px 4px 9px", border: 0, padding: 0 }}>
                                <div style={{ height: "100%", width: "100%" }} className=""><item.name autopopData={autopopData} projectChanged={callApi} /></div>
                            </div>
                        ))}
                    </ResponsiveGridLayout>
                </div>

            </div>
        </div>
    )
}

export default InspectraDashboard;